import { render, staticRenderFns } from "./AddQualifications.vue?vue&type=template&id=2ab7a0ce&scoped=true"
import script from "./AddQualifications.vue?vue&type=script&lang=js"
export * from "./AddQualifications.vue?vue&type=script&lang=js"
import style0 from "./AddQualifications.vue?vue&type=style&index=0&id=2ab7a0ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab7a0ce",
  null
  
)

export default component.exports